import { DISABLE_USER } from "./types";
import { apiService } from "../utils/serviceApi";

export const getUsersPage = (inactiveUsers, query) => {
  const endpoint = inactiveUsers ? "disabledUsers" : "enabledUsers";
  const params = {
    page: query.page,
    size: query.pageSize,
  };

  if (query.search) {
    params.search = query.search;
  }

  query.filters?.forEach(({ column, value }) => {
    if (column?.field && value) {
      params[column.field] = value;
    }
  });

  return apiService
    .get(`${process.env.REACT_APP_SERVICE_URL}/api/accounts/${endpoint}/paginated`, { params })
    .then(({ data }) => ({
      data: data.content,
      page: data.number,
      totalCount: data.totalElements,
    }));
};

export const disableUserBySysadmin =
  (id, setConfirmationDisableUser, setUserIDForArchive, refreshUsers) => async (dispatch) => {
    return apiService
      .put(
        `${process.env.REACT_APP_SERVICE_URL}/api/accounts/disableUser/${id}`
      )
      .then(() => {
        dispatch({
          type: DISABLE_USER,
          payload: id,
        });
        refreshUsers();
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        setConfirmationDisableUser(false);
        setUserIDForArchive("");
      });
  };

export const enableUserBySysadmin =
  (id, setConfirmationDisableUser, setUserIDForArchive, refreshUsers) => async (dispatch) => {
    return apiService
      .put(`${process.env.REACT_APP_SERVICE_URL}/api/accounts/enableUser/${id}`)
      .then(() => {
        dispatch({
          type: DISABLE_USER,
          payload: id,
        });
        refreshUsers();
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        setConfirmationDisableUser(false);
        setUserIDForArchive("");
      });
  };


export const requestPasswordResetBySysadmin = (
    email,
    setConfirmationResetPassword,
    setUserEmailForResetPassword
) => async (dispatch) => {
    apiService
        .post(
        `${process.env.REACT_APP_SERVICE_URL}/api/accounts/password/${email}`,
        { email: email }
        )
        .then(() => {
        console.log("Password reset request sent");
        })
        .catch((e) => {
        console.log(e);
        })
        .finally(() => {
        setConfirmationResetPassword(false);
        setUserEmailForResetPassword("");
        });
}
